"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shouldAsyncValidate = function () { return true; };
exports.default = shouldAsyncValidate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-yup/src/shouldAsyncValidate.js
// module id = 1455
// module chunks = 2